module.exports = __webpack_public_path__ + "static/media/seminar3.c5d37587.jpg";